const FORMULA_PREFIX = /^[\t\r ]*[=+\-@]/;

export const escapeCsvCell = (value) => {
  if (value === null || value === undefined) return '""';

  let text = String(value);
  if (FORMULA_PREFIX.test(text)) {
    text = `'${text}`;
  }

  return `"${text.replace(/"/g, '""')}"`;
};

export const serializeCsv = (rows) =>
  `\uFEFF${rows.map((row) => row.map(escapeCsvCell).join(",")).join("\r\n")}`;

export const downloadCsv = (rows, filename) => {
  if (!Array.isArray(rows) || rows.length === 0 || typeof document === "undefined") return;

  const blob = new Blob([serializeCsv(rows)], {type: "text/csv;charset=utf-8"});
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename.endsWith(".csv") ? filename : `${filename}.csv`;
  link.style.display = "none";
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
};
